module.exports = __webpack_public_path__ + "static/media/Online learning-amico (1).c6c73992.png";